<ng-container *ngIf="formGroup">
  <ng-container [formGroup]="formGroup">
    <div class="w-full" [intercomTarget]="'model_node_targetcolumn'">
      <mat-form-field
        class="w-full"
        [ngClass]="isFlatDisplay ? 'h-70px' : 'no-padding'"
        [appearance]="isFlatDisplay ? 'standard' : 'outline'"
      >
        <mat-label>{{ label }}</mat-label>
        <div matPrefix style="width: 15px" class="aligner">
          <ng-container *ngIf="(formGroup.get(formName)?.value | columnType : sourceTable) !== ''">
            <y42-column-type-icon
              [type]="$any(formGroup.get(formName)?.value | columnType : sourceTable)"
            ></y42-column-type-icon>
          </ng-container>
          <div *ngIf="(formGroup.get(formName)?.value | columnType : sourceTable) === ''">
            <img
              src="../../../../../assets/images/table-icons/columns.svg"
              width="20"
              class="relative"
              style="bottom: -2px"
            />
          </div>
        </div>
        <input
          [maxLength]="maxLength"
          matInput
          autocomplete="off"
          type="text"
          [formControlName]="formName"
          [pattern]="allowedColumnPattern"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <div class="pt-2 pl-3 pb-2 font-normal pb-1 fs-08 text-gray-700" style="border-bottom: 1px dashed #e9e9e9">
            Select an existing column to overwrite or create a new one:
          </div>
          <mat-option
            *ngFor="let field of formGroup.get(formName)?.value | filterFields : sourceTable; trackBy: trackByFieldName"
            [value]="field.field_name"
          >
            <div class="aligner-start w-full">
              <y42-column-type-icon [type]="field.data_type"></y42-column-type-icon>
              <div class="ml-1 fs-08 text-gray-700">{{ field.field_name }}</div>
            </div>
          </mat-option>
        </mat-autocomplete>
        <div matSuffix *ngIf="outputTypeName" class="aligner-start" style="width: 88px">
          <div class="fs-07 text-gray-600 mr-2">Output Type</div>
          <button
            mat-icon-button
            type="button"
            class="relative aligner"
            style="width: 15px; height: 15px; border-radius: 3px; top: -2px"
            [matMenuTriggerFor]="typeMenu"
            (click)="$event.stopPropagation()"
          >
            <y42-column-type-icon [type]="formGroup.get(outputTypeName)?.value"></y42-column-type-icon>
          </button>
          <mat-menu #typeMenu="matMenu">
            <button
              *ngFor="let allowedOutputType of state.allowedOutputTypes; trackBy: trackByType"
              type="button"
              mat-menu-item
              class="pl-2 pr-2"
              (click)="onOutputTypeSelected(allowedOutputType.type)"
            >
              <p class="aligner-start">
                <y42-column-type-icon class="mx-1" [type]="allowedOutputType.type"></y42-column-type-icon>
                <span class="fs-08 ml-1 text-gray-700 capitalize">{{ allowedOutputType.label }}</span>
              </p>
            </button>
          </mat-menu>
        </div>
      </mat-form-field>
    </div>
    <div class="relative w-full" [ngStyle]="{ top: isFlatDisplay ? '-15px' : '0' }">
      <p class="pl-2 text-red-700 fs-07" *ngIf="formGroup.get(formName)?.errors && formGroup.get(formName)?.dirty">
        <span *ngIf="formGroup.get(formName)?.errors?.pattern">{{ COLUMN_NAME_NOT_ALLOWED }}</span>
        <span *ngIf="formGroup.get(formName)?.errors?.columnExists">{{ DUPLICATE }}</span>
        <span *ngIf="formGroup.get(formName)?.errors?.moreThanOne"
          >Cannot use the same target column in two different components</span
        >
        <span *ngIf="formGroup.get(formName)?.errors?.usedInGroupBy"
          >Same column used in grouping, please change the column name</span
        >
        <span *ngIf="formGroup.get(formName)?.errors?.targetExists"
          >Cannot use the same target column name for two different columns</span
        >
      </p>
      <p class="pl-2 fs-07 text-gray-600" *ngIf="!formGroup.get(formName)?.value">Please specify a name</p>
      <p
        class="pl-2 fs-07 text-gray-600"
        *ngIf="
          sourceTable &&
          (formGroup.get(formName)?.value | columnType : sourceTable) === '' &&
          !formGroup.get(formName)?.errors
        "
      >
        This will be a new column
      </p>
      <p
        class="pl-2 fs-07 text-gray-600"
        *ngIf="
          sourceTable &&
          (formGroup.get(formName)?.value | columnType : sourceTable) !== '' &&
          !formGroup.get(formName)?.errors
        "
      >
        You will overwrite this existing column -
        <span class="text-gray-1100 font-medium">{{ formGroup.get(formName)?.value }}</span>
      </p>
    </div>
  </ng-container>
</ng-container>
